<div class="notifications">
	<div *ngFor="let notification of notifications; trackBy: trackByIndex" class="notification" [ngClass]="notification.type">
		<ng-container *ngTemplateOutlet="notificationTpl;context:{notification:notification}"></ng-container>
	</div>
</div>

<ng-template #notificationTpl let-notification="notification">
	<div class="title" fxLayout="row" fxLayoutAlign="space-between center">
		<div class="lbl">{{notification.title}}</div>
		<div class="btnX">
			<button mat-icon-button (click)="close(notification)" matTooltip="Cerrar la notificación"
				matTooltipPosition="before">
				<mat-icon>cancel</mat-icon>
			</button>
		</div>
	</div>
	<div class="message" (click)="goUrl(notification)"> {{notification.body}} </div>
</ng-template>